import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, mergeMap, throwError } from 'rxjs';
import { CASO } from '../interfaces/caso.interface';

@Injectable({
  providedIn: 'root'
})
export class CasoService {
  endpointApi = environment.apiCmsCasos;
  apiCmsPosters = environment.apiCmsCasosImages;
  caso: any;

  constructor(private http: HttpClient) { }

  // Handle API errors =================================
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An client error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log("Backend error code " + error.status + ", body was: " + JSON.stringify(error.error));
    }
    // return an observable with a user-facing error message
    return throwError(() => error.error)
  }

  getCaso(id: number) {
    this.caso = this.http.get<any>(this.endpointApi + '/find?id=' + id)
      .pipe(
        map(resp => {
          return resp.data.case;
        }),
        catchError(this.handleError)
      )
    return this.caso;
  }
  getCasoWithImages(id: number): Observable<any> {
    return this.http.get<any>(this.endpointApi + '/find?id=' + id)
      .pipe(
        mergeMap(resp => {
          const caso = resp.data.case;
          return this.getImagesByCaso(caso.id)
            .pipe(
              map(posters => {
                caso.images = posters;
                return caso;
              })
            )
        }),
        catchError(this.handleError)
      )
  }
  getImagesByCaso(id: string) {
    return this.http.get<any>(this.apiCmsPosters + '/get?fk_idRetalk=' + id)
      .pipe(
        map(resp => resp.data.case_images),
        catchError(this.handleError)
      )
  }

  getCasoPreview(id: number) {
    this.caso = this.http.get<any>(this.endpointApi + 'find?id=' + id)
      .pipe(
        map(resp => {
          return resp.data.article;
        }),
        catchError(this.handleError)
      )
    return this.caso;

  }


}
